import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'
import fileDownload from 'js-file-download'

import qs from 'qs'
// 设置baseURL
const protocol = window.location.protocol
axios.defaults.baseURL = protocol + process.env.EVN_AR()
axios.defaults.withCredentials = true
axios.defaults.timeout = 20000

// 请求拦截器
axios.interceptors.request.use(config => {
  if (config.responseType === 'arraybuffer') {
    config.headers['clienttype'] = 'web'
    config.headers['sessiontoken'] = getToken()
  } else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    config.headers['clienttype'] = 'web'
    config.headers['sessiontoken'] = getToken()
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use((response) => {
  const res = response.data
  if (response.status === 200) {
    switch (res.retcode) {
      case '00002': // 未登录时跳转到登录页
        router.push('/').catch(() => {})
        // 让用户去登录
        removeToken()
        break
      default:
        return Promise.resolve(res)
    }
  } else {
    return Promise.reject(res)
  }
}, (error) => {
  return Promise.reject(error)
})

// get请求
export function get (url, params) {
  // let jsonParams = JSON.stringify(params)
  // jsonParams = encodeURIComponent(jsonParams)
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// post请求
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const downloadFile = async (url, fileName) => {
  await axios.post(url, { responseType: 'blob' }) // arraybuffer
    .then(res => {
      // fileDownload(res.data, fileName)
      download(res, fileName)
    })
}

export const download = (resp, fileName) => {
  const blob = new Blob([resp.data], { type: 'application/octet-binary' })
  // 创建下载的链接
  const href = window.URL.createObjectURL(blob)
  downloadBlob(href, fileName)
}

export const downloadBlob = (blobUrl, fileName, revokeObjectURL) => {
  const downloadElement = document.createElement('a')
  downloadElement.href = blobUrl
  // 下载后文件名
  downloadElement.download = fileName
  document.body.appendChild(downloadElement)
  // 点击下载
  downloadElement.click()
  // 下载完成移除元素
  document.body.removeChild(downloadElement)
  if (revokeObjectURL == null || revokeObjectURL) {
    // 释放掉blob对象
    window.URL.revokeObjectURL(blobUrl)
  }
}



// WEBPACK FOOTER //
// ./src/service/http.js